// extracted by mini-css-extract-plugin
export var active = "_sg-1";
export var circle = "_sg-0";
export var completed = "_sg-2";
export var connector = "_sg-4";
export var connectorCompleted = "_sg-7";
export var connectorSpacer = "_sg-5";
export var iconStrokeOverride = "_sg-8";
export var labelContainer = "_sg-6";
export var pending = "_sg-3";